(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/get-system-price/assets/javascripts/get-system-price.js') >= 0) return;  svs.modules.push('/components/lb-utils/get-system-price/assets/javascripts/get-system-price.js');

'use strict';

const MALTIPSET = svs.utils.products.productIds.MALTIPSET;
const MALTIPSET_PRICE_MULTIPLIER = 2.5;

const getSystemPrice = (systemSize, systemType, productId) => {
  if (productId === MALTIPSET) {
    return systemType === 'SROW' ? systemSize * MALTIPSET_PRICE_MULTIPLIER : systemSize;
  }
  return systemSize;
};
setGlobal('svs.components.lbUi.getSystemPrice', getSystemPrice);

 })(window);